import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "./contexts/AuthContext";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import "./App.css";

/**
 * Top-level application component.
 * Renders the Login page when unauthenticated, and the Dashboard otherwise.
 */
function App() {
  const { user } = useAuth();

  return (
    <div className="app">
      <Routes>
        <Route
          path="/login"
          element={user ? <Navigate to="/" replace /> : <Login />}
        />
        <Route
          path="/*"
          element={user ? <Dashboard /> : <Navigate to="/login" replace />}
        />
      </Routes>
    </div>
  );
}

export default App;
